export default __webpack_public_path__ + "static/media/bg9.303a2e6a.jpg";